import { replaceSerCodigo } from "../QueryParams";
import agendaApiConfig from "./agendaApiConfig";
import ManageStorage from 'src/shared/global/manageStorage';

const SucursalService = {
    async getAll () {
        // console.log("sucursal API ....", process.env.REACT_APP_SERVICIO )
        let query =  {}; 
        // if(process.env.REACT_APP_SERVICIO == ""){
        //     query = null;
        // }else{
        //     query =  {ser_codigo : process.env.REACT_APP_SERVICIO }; 
        // }
        let clinica = ManageStorage.getValueFromStorage("clinica");
        console.log("SUCURSAL => ", query)           
        query = replaceSerCodigo(clinica, query)
        return await agendaApiConfig.get("/sucursal", {
            params: {
                ...query
            }
        });
        


    }
}

export default SucursalService;